import { render, staticRenderFns } from "./PartnerOnPause.vue?vue&type=template&id=7f12ff9e"
import script from "./PartnerOnPause.vue?vue&type=script&lang=js"
export * from "./PartnerOnPause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports